import type { AfterViewInit, OnInit } from '@angular/core';
import { Component, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'invd-rcr-exchange-container',
  templateUrl: './rcr-exchange-container.component.html',
  styleUrls: ['./rcr-exchange-container.component.scss'],
})
export class RcrExchangeContainerComponent implements OnInit, AfterViewInit {
  public steps: Array<object>;
  public currentStep = '/rcr-exchange/lookup';
  public ignoreRoute: boolean;

  private router = inject(Router);

  ngOnInit() {
    this.buildProgressBar();
  }

  ngAfterViewInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd && this.router.url === '/rcr-exchange/confirm') {
        this.ignoreRoute = true;
      }
    });
  }

  private buildProgressBar(): void {
    this.steps = [
      {
        title: 'Find a Deal',
        url: '/rcr-exchange/lookup',
      },
      {
        title: 'Enter Balances',
        url: '/enter-balances',
      },
      {
        title: 'Review & Commit',
        url: '/review-and-commit',
      },
      {
        title: 'Confirmation',
        url: '/confirmation',
      },
    ];
  }
}
